import { SENSORS_ACTION_TYPE } from '../constants'

// ---------------------------------------------
export const updateOpenAppDataAction = (payload) => ({
  type: SENSORS_ACTION_TYPE.UPDATE_OPEN_APP_DATA,
  payload
})

export const cleanOpenAppDataAction = (payload) => ({
  type: SENSORS_ACTION_TYPE.CLEAN_OPEN_APP_DATA,
  payload
})

